import React from 'react';
import { Typography } from '@progress/kendo-react-common';
import CpsPage from './CpsPage';
import { useGlobalizationContext, useTranslation, useUiAdminConfigsContext } from '@cs-cms/state-management';
import { CpsHelpCenterState } from '@cs-cms/types';
import { useUIConfig } from '../UiProvider';

export const AccessDeniedPage: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { uiAdminConfigState } = useUiAdminConfigsContext();
  const { meta } = useUIConfig();

  const helpCenterAccessDeniedItem = (uiAdminConfigState.helpCenter as CpsHelpCenterState)?.items?.find(
    item => item.openAccess
  );

  return (
    <CpsPage className="cpsPage--accessDenied">
      <Typography.h2>{translate('custom.accessDeniedPage.title')}</Typography.h2>
      <Typography.p>{translate('custom.accessDeniedPage.description', { appName: meta.title })}</Typography.p>
      {helpCenterAccessDeniedItem && (
        <a href={helpCenterAccessDeniedItem.url} target="_blank" rel="noreferrer" className="accessDeniedManualLink">
          {helpCenterAccessDeniedItem.name}
        </a>
      )}
    </CpsPage>
  );
};
